"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const userPreference_model_1 = require("../models/userPreference.model");
class UserPreferenceService {
    get userPreferences() {
        return this._userPreferences;
    }
    constructor($window, $uibModal, $log, remoteConfiguration, XucLink, $rootScope) {
        this.$window = $window;
        this.$uibModal = $uibModal;
        this.$log = $log;
        this.remoteConfiguration = remoteConfiguration;
        this.XucLink = XucLink;
        this.$rootScope = $rootScope;
        this._userPreferences = undefined;
        this.opened = false;
        this.modalInstance = undefined;
        this.timeout = 15000;
        this.timer = undefined;
        this.NEW_NB_MISSED_CALLS = "newNbMissedCalls";
        this.USER_PREFERENCES_UPDATE = "userPreferencesUpdated";
        this.MOBILE_APP_PAIRING_NOTIFIED = "mobileAppPairingNotified";
        this.unInit = () => {
            this.$log.info("Unloading UserPreference service");
            this._userPreferences = undefined;
        };
        this.mobileAppMap = {
            [userPreference_model_1.UserPreferencePreferredDevice.WebApp]: Object.freeze({
                webrtc: true,
                mobile: false,
                phone: false,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.MobileApp]: Object.freeze({
                webrtc: false,
                mobile: true,
                phone: false,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileApp]: Object.freeze({
                webrtc: true,
                mobile: true,
                phone: false,
            }),
        };
        this.uaMap = {
            [userPreference_model_1.UserPreferencePreferredDevice.WebApp]: Object.freeze({
                webrtc: true,
                mobile: false,
                phone: false,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.MobileApp]: Object.freeze({
                webrtc: false,
                mobile: true,
                phone: false,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileApp]: Object.freeze({
                webrtc: true,
                mobile: true,
                phone: false,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.Phone]: Object.freeze({
                webrtc: false,
                mobile: false,
                phone: true,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.PhoneAndWebApp]: Object.freeze({
                webrtc: true,
                mobile: false,
                phone: true,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.PhoneAndMobileApp]: Object.freeze({
                webrtc: false,
                mobile: true,
                phone: true,
            }),
            [userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileAppAndPhone]: Object.freeze({
                webrtc: true,
                mobile: true,
                phone: true,
            }),
        };
    }
    init() {
        var _a;
        this.$log.info("Starting UserPreference service");
        this.XucLink.whenLoggedOut().then(this.unInit);
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setHandler(this.$window.Cti.MessageType.USERPREFERENCE, this.onGetUserPreference.bind(this));
    }
    onGetUserPreference(userPreference) {
        var _a, _b;
        this._userPreferences = userPreference;
        if (!(0, lodash_1.isNil)(this._userPreferences) &&
            !(0, lodash_1.isNil)(this._userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall]) &&
            !isNaN(parseInt(this._userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall].value))) {
            this.$rootScope.$broadcast(this.NEW_NB_MISSED_CALLS, parseInt(this._userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall].value));
        }
        if (this.opened)
            return;
        if (!(0, lodash_1.isNil)(this._userPreferences) &&
            !(0, lodash_1.isNil)(this._userPreferences[userPreference_model_1.UserPreferenceKey.MobileAppInfo]) &&
            this._userPreferences[userPreference_model_1.UserPreferenceKey.MobileAppInfo].value ===
                userPreference_model_1.UserPreferenceBoolean.True &&
            !((_a = this.remoteConfiguration) === null || _a === void 0 ? void 0 : _a.isAgent()) &&
            !((_b = this.remoteConfiguration) === null || _b === void 0 ? void 0 : _b.isManager()) &&
            !this.remoteConfiguration.hasSwitchBoard()) {
            this.modalInstance = this.$uibModal.open({
                templateUrl: "assets/javascripts/xchelper/controllers/notificationModal.controller.html",
                size: "sm",
                controller: "NotificationModalController",
                resolve: {},
            });
            this.opened = true;
            this.$rootScope.$broadcast(this.MOBILE_APP_PAIRING_NOTIFIED);
            this.modalInstance.result.catch(() => {
                if (this.timer)
                    clearTimeout(this.timer);
                this.$log.debug("modal closed");
                this.modalInstance = undefined;
                this.onChangeMobileAppInfo(userPreference_model_1.UserPreferenceBoolean.False);
                this.opened = false;
            });
        }
        this.$rootScope.$broadcast(this.USER_PREFERENCES_UPDATE);
    }
    onCleanUserPreference() {
        this._userPreferences = undefined;
    }
    onChangeUserPreference(key, value, value_type) {
        var _a;
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setUserPreference(key, value, value_type);
    }
    onChangePreferredDevice(value) {
        var _a;
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setUserPreference(userPreference_model_1.UserPreferenceKey.PreferredDevice, value, userPreference_model_1.UserPreferenceValueType.string);
    }
    onChangeMobileAppInfo(value) {
        var _a;
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setUserPreference(userPreference_model_1.UserPreferenceKey.MobileAppInfo, value, userPreference_model_1.UserPreferenceValueType.boolean);
    }
    resetMissedCalls() {
        var _a;
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setUserPreference(userPreference_model_1.UserPreferenceKey.NbMissedCall, "0", userPreference_model_1.UserPreferenceValueType.string);
    }
    getPreferredDeviceKey(model) {
        return [
            model.phone ? "1" : "0",
            model.mobile ? "1" : "0",
            model.webrtc ? "1" : "0",
        ].join("");
    }
    getPreferenceFromKey(key) {
        const preferenceMap = {
            "111": userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileAppAndPhone,
            "011": userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileApp,
            "001": userPreference_model_1.UserPreferencePreferredDevice.WebApp,
            "110": userPreference_model_1.UserPreferencePreferredDevice.PhoneAndMobileApp,
            "101": userPreference_model_1.UserPreferencePreferredDevice.PhoneAndWebApp,
            "100": userPreference_model_1.UserPreferencePreferredDevice.Phone,
            "010": userPreference_model_1.UserPreferencePreferredDevice.MobileApp,
        };
        return preferenceMap[key];
    }
    getPreferredDeviceFromModel(model) {
        const key = this.getPreferredDeviceKey(model);
        return this.getPreferenceFromKey(key);
    }
    getPrefferedDeviceModel(usingMobileApp, usingUa) {
        let preferedDevice = this.getPreferredDevice(usingUa);
        if (usingUa) {
            return (this.uaMap[preferedDevice] || {
                webrtc: true,
                mobile: usingMobileApp,
                phone: true,
            });
        }
        else {
            return (this.mobileAppMap[preferedDevice] || {
                webrtc: true,
                mobile: true,
                phone: false,
            });
        }
    }
    setPreferredDeviceFromModel(model) {
        this.onChangePreferredDevice(this.getPreferredDeviceFromModel(model));
    }
    getPreferredDevice(isUa = false) {
        let defaultPref = isUa ? userPreference_model_1.UserPreferencePreferredDevice.PhoneAndWebApp : userPreference_model_1.UserPreferencePreferredDevice.WebAppAndMobileApp;
        return this.userPreferences &&
            this.userPreferences[userPreference_model_1.UserPreferenceKey.PreferredDevice]
            ? this.userPreferences[userPreference_model_1.UserPreferenceKey.PreferredDevice].value
            : defaultPref;
    }
    getMissedCalls() {
        return this.userPreferences &&
            this.userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall] &&
            !isNaN(parseInt(this.userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall].value))
            ? parseInt(this.userPreferences[userPreference_model_1.UserPreferenceKey.NbMissedCall].value)
            : 0;
    }
}
exports.default = UserPreferenceService;
UserPreferenceService.$inject = [
    "$window",
    "$uibModal",
    "$log",
    "remoteConfiguration",
    "XucLink",
    "$rootScope",
];
